// import React, { useState } from "react";
// import { X } from "react-feather";
// import { Modal } from "react-bootstrap";

// const DetailModal = ({ selectedDetailModal, setSelectedDetailModal }) => {
//   const [detailModalView, setDetailModalView] = useState("market_share");

//   const detailedCompetitiveData = {
//     "tech-0": {
//       name: "Water-Based Adhesives",
//       type: "Technology",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "28%",
//           revenue: "35% of Henkel revenue",
//           focus: "Packaging, construction, woodworking applications",
//           details:
//             "Water-based is largest segment (23.7-38.4% share) due to low VOC regulations.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Strong",
//           marketShare: "19%",
//           revenue: "30% of H.B. Fuller revenue",
//           focus: "Hygiene, packaging applications",
//           details: "Strong position through scoring +5 points.",
//         },
//         {
//           name: "Bostik",
//           position: "Strong",
//           marketShare: "15%",
//           revenue: "28% of Bostik revenue",
//           focus: "Construction, flooring",
//           details: "Arkema backing enables continued investment.",
//         },
//         {
//           name: "Tailored",
//           position: "Strong",
//           marketShare: "5%",
//           revenue: "65% of Tailored revenue",
//           focus: "Woodworking, furniture",
//           details: "Core technology for regional US woodworking applications.",
//         },
//       ],
//       keyTakeaways:
//         "Water-based dominates at $18.5B due to tightening VOC regulations globally. All 4 players compete here—this is a crowded red ocean where price competition is intense.",
//     },
//     "tech-1": {
//       name: "Hot-Melt Adhesives",
//       type: "Technology",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "26%",
//           revenue: "32% of Henkel revenue",
//           focus: "Packaging, hygiene, automotive",
//           details: "Henkel leads hot-melt with EVA and PUR technologies.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Leader",
//           marketShare: "24%",
//           revenue: "38% of H.B. Fuller revenue",
//           focus: "Hygiene, packaging, assembly",
//           details:
//             "H.B. Fuller co-leader in hot-melt with APAO and PUR technologies.",
//         },
//         {
//           name: "Bostik",
//           position: "Strong",
//           marketShare: "18%",
//           revenue: "22% of Bostik revenue",
//           focus: "Packaging, tapes, labels",
//           details:
//             "Strong PSA hot-melt capabilities through Ashland acquisition.",
//         },
//         {
//           name: "Tailored",
//           position: "Moderate",
//           marketShare: "6%",
//           revenue: "25% of Tailored revenue",
//           focus: "Woodworking edge banding",
//           details:
//             "Specialized hot-melts for furniture and woodworking applications.",
//         },
//       ],
//       keyTakeaways:
//         "Hot-melt ($14.2B) is H.B. Fuller's strength at 38% of revenue—highest among all segments. Co-leadership with Henkel (26% vs 24% share) in a 4-player market creates pricing pressure.",
//     },
//     "tech-2": {
//       name: "Reactive (PUR) Adhesives",
//       type: "Technology",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "35%",
//           revenue: "18% of Henkel revenue",
//           focus: "Automotive structural bonding, construction",
//           details:
//             "Henkel dominates reactive adhesives with epoxy and PUR technologies.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Strong",
//           marketShare: "28%",
//           revenue: "16% of H.B. Fuller revenue",
//           focus: "Automotive, electronics, construction",
//           details: "Strong PUR capabilities for demanding applications.",
//         },
//         {
//           name: "Bostik",
//           position: "Moderate",
//           marketShare: "22%",
//           revenue: "14% of Bostik revenue",
//           focus: "Construction, industrial",
//           details: "Moderate position in reactive adhesives.",
//         },
//       ],
//       keyTakeaways:
//         "Reactive adhesives ($8.6B) offer premium pricing due to superior performance. Only 3 players compete—Henkel leads at 35%, H.B. Fuller strong at 28%.",
//     },
//     "tech-3": {
//       name: "Pressure-Sensitive Adhesives",
//       type: "Technology",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "32%",
//           revenue: "12% of Henkel revenue",
//           focus: "Tapes, labels, graphics",
//           details: "Henkel leads PSA through Loctite brand.",
//         },
//         {
//           name: "Bostik",
//           position: "Strong",
//           marketShare: "28%",
//           revenue: "16% of Bostik revenue",
//           focus: "Labels, tapes, medical",
//           details:
//             "Bostik strengthened PSA position through Ashland acquisition.",
//         },
//       ],
//       keyTakeaways:
//         "PSA ($9.2B) is a blue ocean with only 2 players—Henkel (32%) and Bostik (28%). H.B. Fuller currently absent from PSA creates strategic gap.",
//     },
//     "app-0": {
//       name: "Construction",
//       type: "Application",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "29%",
//           revenue: "38% of Henkel revenue",
//           focus: "Premium construction, automotive, electronics",
//           details: "Construction is largest adhesives segment globally.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Growing",
//           marketShare: "14%",
//           revenue: "18% of H.B. Fuller revenue",
//           focus: "Mid-market construction",
//           details: "Growing presence through acquisitions like Fourny (2022).",
//         },
//         {
//           name: "Bostik",
//           position: "Leader",
//           marketShare: "27%",
//           revenue: "45% of Bostik revenue",
//           focus: "Flooring, tiles, roofing",
//           details:
//             "Dominant in construction with strong contractor relationships.",
//         },
//         {
//           name: "Tailored",
//           position: "Limited",
//           marketShare: "2%",
//           revenue: "8% of Tailored revenue",
//           focus: "Wood construction only",
//           details: "Minimal presence, limited to US woodworking segment.",
//         },
//       ],
//       keyTakeaways:
//         "Construction ($10.8B) is largest application but Henkel (29%) and Bostik (27%) dominate through decades-old contractor relationships.",
//     },
//     "app-1": {
//       name: "Packaging",
//       type: "Application",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "30%",
//           revenue: "26% of Henkel revenue",
//           focus: "Food packaging, flexible packaging",
//           details: "Henkel leads packaging with broad portfolio.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Strong",
//           marketShare: "22%",
//           revenue: "24% of H.B. Fuller revenue",
//           focus: "Sustainable packaging, food-safe",
//           details: "Strong packaging position with focus on sustainability.",
//         },
//         {
//           name: "Bostik",
//           position: "Strong",
//           marketShare: "20%",
//           revenue: "18% of Bostik revenue",
//           focus: "Flexible packaging, labels",
//           details: "Kizen LIME launch (2024) with 80% renewable content.",
//         },
//         {
//           name: "Tailored",
//           position: "Limited",
//           marketShare: "4%",
//           revenue: "10% of Tailored revenue",
//           focus: "Wood-based packaging",
//           details: "Limited to wood packaging like crates and pallets.",
//         },
//       ],
//       keyTakeaways:
//         "Packaging ($12.5B) is second largest application with intense 4-player competition. H.B. Fuller holds strong #2 position at 22% share.",
//     },
//     "app-2": {
//       name: "Hygiene & Nonwovens",
//       type: "Application",
//       companies: [
//         {
//           name: "H.B. Fuller",
//           position: "Leader",
//           marketShare: "45%",
//           revenue: "34% of H.B. Fuller revenue",
//           focus: "Diaper elastic, feminine care",
//           details:
//             "H.B. Fuller dominates hygiene with dedicated innovation centers.",
//         },
//         {
//           name: "Henkel",
//           position: "Strong",
//           marketShare: "38%",
//           revenue: "16% of Henkel revenue",
//           focus: "Premium baby care, adult incontinence",
//           details:
//             "Strong second position leveraging consumer goods relationships.",
//         },
//       ],
//       keyTakeaways:
//         "Hygiene ($3.8B) is H.B. Fuller's crown jewel and most profitable segment—45% market share, 34% of company revenue. DEFEND AT ALL COSTS.",
//     },
//     "app-3": {
//       name: "Air Filtration",
//       type: "Application",
//       companies: [
//         {
//           name: "H.B. Fuller",
//           position: "Leader",
//           marketShare: "52%",
//           revenue: "8% of H.B. Fuller revenue",
//           focus: "HEPA filters, V-cell filters, automotive cabin filters",
//           details:
//             "H.B. Fuller is clear leader in air filtration adhesives with specialized hot-melt and reactive technologies.",
//         },
//       ],
//       keyTakeaways:
//         "Air Filtration ($2.1B, 8.2% CAGR) is H.B. Fuller's green ocean—52% market share with virtually no competition. Growing 8.2% annually.",
//     },
//     "app-4": {
//       name: "Woodworking & Furniture",
//       type: "Application",
//       companies: [
//         {
//           name: "Tailored",
//           position: "Leader",
//           marketShare: "38%",
//           revenue: "75% of Tailored revenue",
//           focus: "Furniture, cabinets, plywood",
//           details:
//             "Tailored dominates US regional woodworking with custom formulations.",
//         },
//         {
//           name: "Henkel",
//           position: "Moderate",
//           marketShare: "24%",
//           revenue: "6% of Henkel revenue",
//           focus: "Global furniture brands",
//           details: "Serves large international furniture manufacturers.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Moderate",
//           marketShare: "16%",
//           revenue: "5% of H.B. Fuller revenue",
//           focus: "North American furniture",
//           details:
//             "Moderate presence targeting larger furniture manufacturers.",
//         },
//         {
//           name: "Bostik",
//           position: "Limited",
//           marketShare: "10%",
//           revenue: "3% of Bostik revenue",
//           focus: "European furniture",
//           details:
//             "Limited presence with some overlap from construction flooring.",
//         },
//       ],
//       keyTakeaways:
//         "Woodworking ($4.2B, 4.9% CAGR slowest) is declining in developed markets with intense 4-player competition.",
//     },
//     "geo-0": {
//       name: "North America",
//       type: "Geography",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Strong",
//           marketShare: "24%",
//           revenue: "20-23% of Henkel revenue",
//           focus: "Broad applications presence",
//           details: "North America is mature market (~20-23% global share).",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Dominant",
//           marketShare: "32%",
//           revenue: "~50% of H.B. Fuller revenue",
//           focus: "Primary market, all applications",
//           details:
//             "H.B. Fuller generates approximately 50% revenue from North America.",
//         },
//         {
//           name: "Bostik",
//           position: "Moderate",
//           marketShare: "16%",
//           revenue: "~25% of Bostik revenue",
//           focus: "Construction, packaging",
//           details: "North America is secondary market for Bostik.",
//         },
//         {
//           name: "Tailored",
//           position: "US Only",
//           marketShare: "8%",
//           revenue: "100% of Tailored revenue",
//           focus: "Woodworking niche",
//           details:
//             "Tailored is US-only player with 4 facilities in North Carolina.",
//         },
//       ],
//       keyTakeaways:
//         "North America ($15.2B, 4.5% CAGR slowest) represents ~20-23% of global market but H.B. Fuller generates 50% of revenue here—massive overweight.",
//     },
//     "geo-1": {
//       name: "Europe",
//       type: "Geography",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "35%",
//           revenue: "42% of Henkel revenue",
//           focus: "All applications, strong construction",
//           details:
//             "Henkel dominates Europe as home market with headquarters in Germany.",
//         },
//         {
//           name: "Bostik",
//           position: "Strong",
//           marketShare: "28%",
//           revenue: "48% of Bostik revenue",
//           focus: "Construction, contractor networks",
//           details: "Bostik strong in Europe (French owned by Arkema).",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Growing",
//           marketShare: "18%",
//           revenue: "~28% of H.B. Fuller revenue",
//           focus: "Building European scale",
//           details: "Growing presence through Fourny acquisition (2022).",
//         },
//       ],
//       keyTakeaways:
//         "Europe ($16.8B, 4.8% CAGR) is second largest region where Henkel (35%) and Bostik (28%) dominate through decades of presence.",
//     },
//     "geo-2": {
//       name: "Asia Pacific",
//       type: "Geography",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "32%",
//           revenue: "35% of Henkel revenue",
//           focus: "China, India manufacturing hubs",
//           details: "Henkel leads APAC with extensive manufacturing network.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Growing",
//           marketShare: "22%",
//           revenue: "~22% of H.B. Fuller revenue",
//           focus: "Expanding manufacturing",
//           details:
//             "H.B. Fuller underweight in APAC. Critical expansion opportunity.",
//         },
//         {
//           name: "Bostik",
//           position: "Moderate",
//           marketShare: "16%",
//           revenue: "~27% of Bostik revenue",
//           focus: "India focus, selective",
//           details: "Bostik selective APAC presence with focus on India.",
//         },
//       ],
//       keyTakeaways:
//         "APAC ($22.4B, 7.3% CAGR fastest) is the CRITICAL opportunity—largest region globally at 36.2% of market and growing fastest.",
//     },
//     "seg-0": {
//       name: "Construction Contractors",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "30%",
//           revenue: "~32% of Henkel revenue",
//           focus: "Premium contractors, large projects",
//           details: "Construction contractors are key segment for 3 players.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Growing",
//           marketShare: "16%",
//           revenue: "~16% of H.B. Fuller revenue",
//           focus: "Mid-market contractors",
//           details: "Growing mid-market contractor relationships.",
//         },
//         {
//           name: "Bostik",
//           position: "Strong",
//           marketShare: "28%",
//           revenue: "~42% of Bostik revenue",
//           focus: "Training programs, certification",
//           details:
//             "Strong contractor training programs and certification across Europe.",
//         },
//       ],
//       keyTakeaways:
//         "Construction contractors ($10.8B) are dominated by Henkel (30%) and Bostik (28%) who invest heavily in training programs.",
//     },
//     "seg-1": {
//       name: "Automotive OEMs",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "42%",
//           revenue: "~20% of Henkel revenue",
//           focus: "EV battery assembly, structural bonding",
//           details:
//             "Henkel dominates automotive OEMs with battery testing center (2024).",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Strong",
//           marketShare: "35%",
//           revenue: "~14% of H.B. Fuller revenue",
//           focus: "Automotive filtration, interior",
//           details: "Strong position leveraging air filtration expertise.",
//         },
//       ],
//       keyTakeaways:
//         "Automotive OEMs ($8.2B, 7.1% CAGR) is dominated by Henkel (42%) with battery testing center for EV applications.",
//     },
//     "seg-2": {
//       name: "Packaging Converters",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "H.B. Fuller",
//           position: "Leader",
//           marketShare: "32%",
//           revenue: "~22% of H.B. Fuller revenue",
//           focus: "Sustainable packaging, food-safe",
//           details:
//             "H.B. Fuller leads packaging converters with focus on sustainability.",
//         },
//         {
//           name: "Bostik",
//           position: "Strong",
//           marketShare: "28%",
//           revenue: "~19% of Bostik revenue",
//           focus: "Flexible packaging, sustainable",
//           details:
//             "Bostik launched sustainable Kizen LIME (80% renewable) in 2024.",
//         },
//       ],
//       keyTakeaways:
//         "Packaging converters ($12.5B) show tight 2-player competition between H.B. Fuller (32% leader) and Bostik (28%).",
//     },
//     "seg-3": {
//       name: "Hygiene Manufacturers",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "H.B. Fuller",
//           position: "Leader",
//           marketShare: "48%",
//           revenue: "~32% of H.B. Fuller revenue",
//           focus: "Diaper elastic bonding, feminine care",
//           details:
//             "H.B. Fuller is clear leader in hygiene with dedicated innovation centers.",
//         },
//       ],
//       keyTakeaways:
//         "Hygiene manufacturers ($4.2B, 6.8% CAGR) is H.B. Fuller's CROWN JEWEL—48% market share, 32% of company revenue.",
//     },
//     "seg-4": {
//       name: "Wood Manufacturers",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "Tailored",
//           position: "Leader",
//           marketShare: "42%",
//           revenue: "~78% of Tailored revenue",
//           focus: "Custom formulations, regional service",
//           details:
//             "Tailored Chemical dominates US regional woodworking with 100% focus.",
//         },
//       ],
//       keyTakeaways:
//         "Wood manufacturers ($4.2B, 4.9% CAGR slowest) is Tailored Chemical's entire business (42% share, 78% of their revenue).",
//     },
//     "custseg-0": {
//       name: "Packaging Converters & CPG Manufacturers",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "28%",
//           revenue: "~24% of Henkel revenue",
//           focus: "Food packaging, CPG brands",
//           details:
//             "All major players serve packaging converters and CPG manufacturers.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Strong",
//           marketShare: "24%",
//           revenue: "~22% of H.B. Fuller revenue",
//           focus: "Sustainable packaging, food-safe",
//           details: "Strong position in packaging converters.",
//         },
//         {
//           name: "Bostik",
//           position: "Strong",
//           marketShare: "21%",
//           revenue: "~19% of Bostik revenue",
//           focus: "Flexible packaging, sustainable",
//           details:
//             "Bostik launched sustainable Kizen LIME (80% renewable) in 2024.",
//         },
//         {
//           name: "Tailored",
//           position: "Moderate",
//           marketShare: "3%",
//           revenue: "~8% of Tailored revenue",
//           focus: "Wood-based packaging only",
//           details:
//             "Limited to wood-based packaging like crates in US regional markets.",
//         },
//       ],
//       keyTakeaways:
//         "Packaging converters are battlefield segment with all 4 players competing for CPG manufacturers. E-commerce driving 8-10% annual growth.",
//     },
//     "custseg-1": {
//       name: "Construction Contractors & Building Material Suppliers",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "Bostik",
//           position: "Leader",
//           marketShare: "32%",
//           revenue: "~42% of Bostik revenue",
//           focus: "Training programs, contractor certification",
//           details:
//             "Construction contractors major segment (44.7% of market). Bostik leader.",
//         },
//         {
//           name: "Henkel",
//           position: "Strong",
//           marketShare: "28%",
//           revenue: "~32% of Henkel revenue",
//           focus: "Premium contractors, large projects",
//           details: "Henkel strong but focused on premium segment.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Growing",
//           marketShare: "16%",
//           revenue: "~16% of H.B. Fuller revenue",
//           focus: "Mid-market contractors, regional",
//           details:
//             "H.B. Fuller acquired Fourny (2022) building European scale.",
//         },
//         {
//           name: "Tailored",
//           position: "Limited",
//           marketShare: "2%",
//           revenue: "~7% of Tailored revenue",
//           focus: "Wood construction only",
//           details: "Minimal construction presence.",
//         },
//       ],
//       keyTakeaways:
//         "Construction contractors are the LARGEST customer segment at 44.7% of total market—this is where the money is. Bostik dominates with 32% share.",
//     },
//     "custseg-2": {
//       name: "Automotive OEMs & Tier 1 Suppliers",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "Henkel",
//           position: "Leader",
//           marketShare: "42%",
//           revenue: "~20% of Henkel revenue",
//           focus: "EV battery assembly, structural bonding",
//           details:
//             "Henkel leading automotive OEMs with battery testing center (2024).",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Strong",
//           marketShare: "24%",
//           revenue: "~14% of H.B. Fuller revenue",
//           focus: "Automotive filtration, interior",
//           details: "Strong position leveraging air filtration expertise.",
//         },
//         {
//           name: "Bostik",
//           position: "Moderate",
//           marketShare: "12%",
//           revenue: "~8% of Bostik revenue",
//           focus: "Interior components, NVH",
//           details: "Limited automotive presence.",
//         },
//       ],
//       keyTakeaways:
//         "Automotive OEMs represent THE future growth opportunity—EVs use 2x more adhesive than traditional vehicles.",
//     },
//     "custseg-3": {
//       name: "Woodworking & Furniture Manufacturers",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "Tailored",
//           position: "Leader",
//           marketShare: "42%",
//           revenue: "~78% of Tailored revenue",
//           focus: "Custom formulations, regional service",
//           details: "Tailored Chemical dominates US regional woodworking.",
//         },
//         {
//           name: "Henkel",
//           position: "Moderate",
//           marketShare: "28%",
//           revenue: "~7% of Henkel revenue",
//           focus: "Global furniture brands, large scale",
//           details: "Serves large international furniture manufacturers.",
//         },
//         {
//           name: "H.B. Fuller",
//           position: "Moderate",
//           marketShare: "18%",
//           revenue: "~6% of H.B. Fuller revenue",
//           focus: "North American furniture, edge banding",
//           details: "Moderate presence in woodworking.",
//         },
//         {
//           name: "Bostik",
//           position: "Limited",
//           marketShare: "12%",
//           revenue: "~3% of Bostik revenue",
//           focus: "European furniture, flooring overlap",
//           details: "Limited woodworking presence.",
//         },
//       ],
//       keyTakeaways:
//         "Woodworking manufacturers are Tailored Chemical's ENTIRE business model (42% share, 78% of revenue).",
//     },
//     "custseg-4": {
//       name: "Hygiene Product Manufacturers",
//       type: "Customer Segment",
//       companies: [
//         {
//           name: "H.B. Fuller",
//           position: "Leader",
//           marketShare: "48%",
//           revenue: "~32% of H.B. Fuller revenue",
//           focus: "Diaper elastic bonding, feminine care",
//           details:
//             "H.B. Fuller dominates hygiene segment with dedicated innovation centers.",
//         },
//         {
//           name: "Henkel",
//           position: "Strong",
//           marketShare: "35%",
//           revenue: "~17% of Henkel revenue",
//           focus: "Premium adult incontinence, baby care",
//           details: "Strong position leveraging global brand relationships.",
//         },
//         {
//           name: "Bostik",
//           position: "Limited",
//           marketShare: "8%",
//           revenue: "~4% of Bostik revenue",
//           focus: "Selective hygiene applications",
//           details: "Limited presence in hygiene.",
//         },
//       ],
//       keyTakeaways:
//         "Hygiene manufacturers (P&G, Kimberly-Clark) are H.B. Fuller's PROFIT ENGINE—48% market share, 32% of revenue, highest margins.",
//     },
//   };

//   const marketData = {
//     "tech-0": {
//       size: "$18.5B",
//       year: "2024",
//       cagr: "6.2%",
//       period: "2024-2030",
//     },
//     "tech-1": {
//       size: "$14.2B",
//       year: "2024",
//       cagr: "5.8%",
//       period: "2024-2029",
//     },
//     "tech-2": {
//       size: "$8.6B",
//       year: "2024",
//       cagr: "7.5%",
//       period: "2024-2030",
//     },
//     "tech-3": {
//       size: "$9.2B",
//       year: "2024",
//       cagr: "6.1%",
//       period: "2024-2029",
//     },
//     "app-0": {
//       size: "$10.8B",
//       year: "2024",
//       cagr: "5.8%",
//       period: "2024-2029",
//     },
//     "app-1": {
//       size: "$12.5B",
//       year: "2024",
//       cagr: "5.5%",
//       period: "2024-2030",
//     },
//     "app-2": { size: "$3.8B", year: "2024", cagr: "6.8%", period: "2024-2029" },
//     "app-3": { size: "$2.1B", year: "2024", cagr: "8.2%", period: "2024-2030" },
//     "app-4": { size: "$4.2B", year: "2024", cagr: "4.9%", period: "2024-2029" },
//     "geo-0": {
//       size: "$15.2B",
//       year: "2024",
//       cagr: "4.5%",
//       period: "2024-2029",
//     },
//     "geo-1": {
//       size: "$16.8B",
//       year: "2024",
//       cagr: "4.8%",
//       period: "2024-2029",
//     },
//     "geo-2": {
//       size: "$22.4B",
//       year: "2024",
//       cagr: "7.3%",
//       period: "2024-2030",
//     },
//     "seg-0": {
//       size: "$10.8B",
//       year: "2024",
//       cagr: "5.8%",
//       period: "2024-2029",
//     },
//     "seg-1": { size: "$8.2B", year: "2024", cagr: "7.1%", period: "2024-2030" },
//     "seg-2": {
//       size: "$12.5B",
//       year: "2024",
//       cagr: "5.5%",
//       period: "2024-2030",
//     },
//     "seg-3": { size: "$3.8B", year: "2024", cagr: "6.8%", period: "2024-2029" },
//     "seg-4": { size: "$4.2B", year: "2024", cagr: "4.9%", period: "2024-2029" },
//     "custseg-0": {
//       size: "$10.8B",
//       year: "2024",
//       cagr: "5.8%",
//       period: "2024-2029",
//     },
//     "custseg-1": {
//       size: "$12.5B",
//       year: "2024",
//       cagr: "5.5%",
//       period: "2024-2030",
//     },
//     "custseg-2": {
//       size: "$8.2B",
//       year: "2024",
//       cagr: "7.1%",
//       period: "2024-2030",
//     },
//     "custseg-3": {
//       size: "$3.8B",
//       year: "2024",
//       cagr: "6.8%",
//       period: "2024-2029",
//     },
//     "custseg-4": {
//       size: "$4.2B",
//       year: "2024",
//       cagr: "4.9%",
//       period: "2024-2029",
//     },
//   };

//   const renderPositionDots = (position, companyName) => {
//     const dotsCount =
//       position === "Leader" || position === "Dominant"
//         ? 5
//         : position === "Strong"
//         ? 4
//         : position === "Growing" || position === "Moderate"
//         ? 3
//         : position === "Limited"
//         ? 2
//         : position === "None"
//         ? 0
//         : 1;

//     const companyColors = {
//       Henkel: "danger",
//       "H.B. Fuller": "primary",
//       Bostik: "info",
//       Tailored: "secondary",
//     };

//     const color = companyColors[companyName] || "secondary";

//     return (
//       <div className="d-flex gap-1" title={`${companyName}: ${position}`}>
//         {[...Array(5)].map((_, idx) => (
//           <div
//             key={idx}
//             className={`rounded-circle border border-2 ${
//               idx < dotsCount
//                 ? `bg-${color} border-${color}`
//                 : "bg-white border-secondary"
//             }`}
//             style={{
//               width: "0.75rem",
//               height: "0.75rem",
//               transition: "transform 0.2s",
//             }}
//           ></div>
//         ))}
//       </div>
//     );
//   };

//   if (!selectedDetailModal) return null;

//   const modalData = detailedCompetitiveData[selectedDetailModal];
//   if (!modalData) return null;

//   return (
//     <Modal
//       show={!!selectedDetailModal}
//       onHide={() => setSelectedDetailModal(null)}
//       size="xl"
//       centered
//     >
//       <style>{`
//         .modal-header-gradient {
//           background: linear-gradient(135deg, #0d6efd 0%, #6610f2 100%);
//           color: white;
//         }
//         .market-info-bar {
//           background: #e7f3ff;
//           border-bottom: 1px solid #bdd7f0;
//         }
//         .tab-button {
//           padding: 0.5rem 1rem;
//           border-radius: 0.5rem;
//           font-weight: 600;
//           font-size: 0.875rem;
//           transition: all 0.3s;
//           border: none;
//         }
//         .tab-button-active {
//           background: #0d6efd;
//           color: white;
//           box-shadow: 0 2px 4px rgba(13,110,253,0.3);
//         }
//         .tab-button-inactive {
//           background: white;
//           color: #6c757d;
//         }
//         .tab-button-inactive:hover {
//           background: #f8f9fa;
//         }
//         .company-row {
//           transition: all 0.2s;
//         }
//         .company-row:hover {
//           background: #f8f9fa;
//         }
//         .takeaway-box {
//           background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
//           border-left: 4px solid #ff9800;
//         }
//       `}</style>

//       <Modal.Header className="modal-header-gradient">
//         <div className="d-flex justify-content-between align-items-center w-100">
//           <div>
//             <div className="small opacity-75 mb-1">
//               {modalData.type} Deep Dive
//             </div>
//             <Modal.Title className="h4">{modalData.name}</Modal.Title>
//           </div>
//           <button
//             onClick={() => setSelectedDetailModal(null)}
//             className="btn btn-light btn-sm"
//           >
//             <X size={20} />
//           </button>
//         </div>
//       </Modal.Header>

//       {marketData[selectedDetailModal] && (
//         <div className="market-info-bar p-3">
//           <div className="d-flex justify-content-between align-items-center">
//             <div className="d-flex gap-4">
//               <div>
//                 <div className="small text-primary fw-bold text-uppercase mb-1">
//                   Market Size
//                 </div>
//                 <div className="h3 fw-bold mb-0">
//                   {marketData[selectedDetailModal].size}
//                 </div>
//                 <div className="small text-muted">
//                   Global ({marketData[selectedDetailModal].year})
//                 </div>
//               </div>
//               <div className="vr"></div>
//               <div>
//                 <div className="small text-primary fw-bold text-uppercase mb-1">
//                   Growth Rate
//                 </div>
//                 <div className="h3 fw-bold text-success mb-0">
//                   {marketData[selectedDetailModal].cagr}
//                 </div>
//                 <div className="small text-muted">
//                   CAGR {marketData[selectedDetailModal].period}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="bg-light p-3 border-bottom">
//         <div className="d-flex gap-2">
//           {[
//             { id: "market_share", label: "Market Position" },
//             { id: "revenue", label: "Revenue Contribution" },
//             {
//               id: "focus",
//               label:
//                 modalData.type === "Customer Segment"
//                   ? "Key Pain Points"
//                   : "Company Focus",
//             },
//           ].map((tab) => (
//             <button
//               key={tab.id}
//               onClick={() => setDetailModalView(tab.id)}
//               className={`tab-button ${
//                 detailModalView === tab.id
//                   ? "tab-button-active"
//                   : "tab-button-inactive"
//               }`}
//             >
//               {tab.label}
//             </button>
//           ))}
//         </div>
//       </div>

//       <Modal.Body
//         style={{ maxHeight: "calc(100vh - 400px)", overflowY: "auto" }}
//       >
//         <div className="table-responsive">
//           <table className="table table-hover mb-0">
//             <thead className="table-light">
//               <tr>
//                 <th className="fw-bold">Company</th>
//                 <th className="fw-bold">Market Position</th>
//                 {detailModalView === "market_share" && (
//                   <th className="fw-bold">Market Share</th>
//                 )}
//                 {detailModalView === "revenue" && (
//                   <th className="fw-bold">Revenue Contribution</th>
//                 )}
//                 {detailModalView === "focus" && (
//                   <th className="fw-bold">
//                     {modalData.type === "Customer Segment"
//                       ? "Key Pain Points"
//                       : "Strategic Focus"}
//                   </th>
//                 )}
//                 <th className="fw-bold">Key Details</th>
//               </tr>
//             </thead>
//             <tbody>
//               {modalData.companies.map((company, idx) => {
//                 const companyColorClass =
//                   company.name === "Henkel"
//                     ? "table-danger"
//                     : company.name === "H.B. Fuller"
//                     ? "table-primary"
//                     : company.name === "Bostik"
//                     ? "table-info"
//                     : "table-secondary";

//                 return (
//                   <tr key={idx} className={`company-row ${companyColorClass}`}>
//                     <td className="fw-bold">{company.name}</td>
//                     <td>
//                       {renderPositionDots(company.position, company.name)}
//                     </td>
//                     {detailModalView === "market_share" && (
//                       <td className="fw-bold fs-5">{company.marketShare}</td>
//                     )}
//                     {detailModalView === "revenue" && (
//                       <td className="small">{company.revenue}</td>
//                     )}
//                     {detailModalView === "focus" && (
//                       <td className="small">{company.focus}</td>
//                     )}
//                     <td className="small text-muted">{company.details}</td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>

//         <div className="takeaway-box rounded p-3 mt-3">
//           <div className="d-flex gap-2">
//             <span className="fs-4">💡</span>
//             <div>
//               <div className="fw-bold mb-2">Key Takeaways</div>
//               <p className="small mb-0">{modalData.keyTakeaways}</p>
//             </div>
//           </div>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default DetailModal;

import React, { useState } from "react";
import { X } from "react-feather";
import { Modal } from "react-bootstrap";

const DetailModal = ({ selectedDetailModal, setSelectedDetailModal }) => {
  const [detailModalView, setDetailModalView] = useState("market_share");

  const detailedCompetitiveData = {
    "tech-0": {
      name: "Water-Based Adhesives",
      type: "Technology",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "28%",
          revenue: "35% of Henkel revenue",
          focus: "Packaging, construction, woodworking applications",
          details:
            "Water-based is largest segment (23.7-38.4% share) due to low VOC regulations.",
        },
        {
          name: "H.B. Fuller",
          position: "Strong",
          marketShare: "19%",
          revenue: "30% of H.B. Fuller revenue",
          focus: "Hygiene, packaging applications",
          details: "Strong position through scoring +5 points.",
        },
        {
          name: "Bostik",
          position: "Strong",
          marketShare: "15%",
          revenue: "28% of Bostik revenue",
          focus: "Construction, flooring",
          details: "Arkema backing enables continued investment.",
        },
        {
          name: "Tailored",
          position: "Strong",
          marketShare: "5%",
          revenue: "65% of Tailored revenue",
          focus: "Woodworking, furniture",
          details: "Core technology for regional US woodworking applications.",
        },
      ],
      keyTakeaways:
        "Water-based dominates at $18.5B due to tightening VOC regulations globally. All 4 players compete here—this is a crowded red ocean where price competition is intense.",
    },
    "tech-1": {
      name: "Hot-Melt Adhesives",
      type: "Technology",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "26%",
          revenue: "32% of Henkel revenue",
          focus: "Packaging, hygiene, automotive",
          details: "Henkel leads hot-melt with EVA and PUR technologies.",
        },
        {
          name: "H.B. Fuller",
          position: "Leader",
          marketShare: "24%",
          revenue: "38% of H.B. Fuller revenue",
          focus: "Hygiene, packaging, assembly",
          details:
            "H.B. Fuller co-leader in hot-melt with APAO and PUR technologies.",
        },
        {
          name: "Bostik",
          position: "Strong",
          marketShare: "18%",
          revenue: "22% of Bostik revenue",
          focus: "Packaging, tapes, labels",
          details:
            "Strong PSA hot-melt capabilities through Ashland acquisition.",
        },
        {
          name: "Tailored",
          position: "Moderate",
          marketShare: "6%",
          revenue: "25% of Tailored revenue",
          focus: "Woodworking edge banding",
          details:
            "Specialized hot-melts for furniture and woodworking applications.",
        },
      ],
      keyTakeaways:
        "Hot-melt ($14.2B) is H.B. Fuller's strength at 38% of revenue—highest among all segments. Co-leadership with Henkel (26% vs 24% share) in a 4-player market creates pricing pressure.",
    },
    "tech-2": {
      name: "Reactive (PUR) Adhesives",
      type: "Technology",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "35%",
          revenue: "18% of Henkel revenue",
          focus: "Automotive structural bonding, construction",
          details:
            "Henkel dominates reactive adhesives with epoxy and PUR technologies.",
        },
        {
          name: "H.B. Fuller",
          position: "Strong",
          marketShare: "28%",
          revenue: "16% of H.B. Fuller revenue",
          focus: "Automotive, electronics, construction",
          details: "Strong PUR capabilities for demanding applications.",
        },
        {
          name: "Bostik",
          position: "Moderate",
          marketShare: "22%",
          revenue: "14% of Bostik revenue",
          focus: "Construction, industrial",
          details: "Moderate position in reactive adhesives.",
        },
      ],
      keyTakeaways:
        "Reactive adhesives ($8.6B) offer premium pricing due to superior performance. Only 3 players compete—Henkel leads at 35%, H.B. Fuller strong at 28%.",
    },
    "tech-3": {
      name: "Pressure-Sensitive Adhesives",
      type: "Technology",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "32%",
          revenue: "12% of Henkel revenue",
          focus: "Tapes, labels, graphics",
          details: "Henkel leads PSA through Loctite brand.",
        },
        {
          name: "Bostik",
          position: "Strong",
          marketShare: "28%",
          revenue: "16% of Bostik revenue",
          focus: "Labels, tapes, medical",
          details:
            "Bostik strengthened PSA position through Ashland acquisition.",
        },
      ],
      keyTakeaways:
        "PSA ($9.2B) is a blue ocean with only 2 players—Henkel (32%) and Bostik (28%). H.B. Fuller currently absent from PSA creates strategic gap.",
    },
    "app-0": {
      name: "Construction",
      type: "Application",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "29%",
          revenue: "38% of Henkel revenue",
          focus: "Premium construction, automotive, electronics",
          details: "Construction is largest adhesives segment globally.",
        },
        {
          name: "H.B. Fuller",
          position: "Growing",
          marketShare: "14%",
          revenue: "18% of H.B. Fuller revenue",
          focus: "Mid-market construction",
          details: "Growing presence through acquisitions like Fourny (2022).",
        },
        {
          name: "Bostik",
          position: "Leader",
          marketShare: "27%",
          revenue: "45% of Bostik revenue",
          focus: "Flooring, tiles, roofing",
          details:
            "Dominant in construction with strong contractor relationships.",
        },
        {
          name: "Tailored",
          position: "Limited",
          marketShare: "2%",
          revenue: "8% of Tailored revenue",
          focus: "Wood construction only",
          details: "Minimal presence, limited to US woodworking segment.",
        },
      ],
      keyTakeaways:
        "Construction ($10.8B) is largest application but Henkel (29%) and Bostik (27%) dominate through decades-old contractor relationships.",
    },
    "app-1": {
      name: "Packaging",
      type: "Application",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "30%",
          revenue: "26% of Henkel revenue",
          focus: "Food packaging, flexible packaging",
          details: "Henkel leads packaging with broad portfolio.",
        },
        {
          name: "H.B. Fuller",
          position: "Strong",
          marketShare: "22%",
          revenue: "24% of H.B. Fuller revenue",
          focus: "Sustainable packaging, food-safe",
          details: "Strong packaging position with focus on sustainability.",
        },
        {
          name: "Bostik",
          position: "Strong",
          marketShare: "20%",
          revenue: "18% of Bostik revenue",
          focus: "Flexible packaging, labels",
          details: "Kizen LIME launch (2024) with 80% renewable content.",
        },
        {
          name: "Tailored",
          position: "Limited",
          marketShare: "4%",
          revenue: "10% of Tailored revenue",
          focus: "Wood-based packaging",
          details: "Limited to wood packaging like crates and pallets.",
        },
      ],
      keyTakeaways:
        "Packaging ($12.5B) is second largest application with intense 4-player competition. H.B. Fuller holds strong #2 position at 22% share.",
    },
    "app-2": {
      name: "Hygiene & Nonwovens",
      type: "Application",
      companies: [
        {
          name: "H.B. Fuller",
          position: "Leader",
          marketShare: "45%",
          revenue: "34% of H.B. Fuller revenue",
          focus: "Diaper elastic, feminine care",
          details:
            "H.B. Fuller dominates hygiene with dedicated innovation centers.",
        },
        {
          name: "Henkel",
          position: "Strong",
          marketShare: "38%",
          revenue: "16% of Henkel revenue",
          focus: "Premium baby care, adult incontinence",
          details:
            "Strong second position leveraging consumer goods relationships.",
        },
      ],
      keyTakeaways:
        "Hygiene ($3.8B) is H.B. Fuller's crown jewel and most profitable segment—45% market share, 34% of company revenue. DEFEND AT ALL COSTS.",
    },
    "app-3": {
      name: "Air Filtration",
      type: "Application",
      companies: [
        {
          name: "H.B. Fuller",
          position: "Leader",
          marketShare: "52%",
          revenue: "8% of H.B. Fuller revenue",
          focus: "HEPA filters, V-cell filters, automotive cabin filters",
          details:
            "H.B. Fuller is clear leader in air filtration adhesives with specialized hot-melt and reactive technologies.",
        },
      ],
      keyTakeaways:
        "Air Filtration ($2.1B, 8.2% CAGR) is H.B. Fuller's green ocean—52% market share with virtually no competition. Growing 8.2% annually.",
    },
    "app-4": {
      name: "Woodworking & Furniture",
      type: "Application",
      companies: [
        {
          name: "Tailored",
          position: "Leader",
          marketShare: "38%",
          revenue: "75% of Tailored revenue",
          focus: "Furniture, cabinets, plywood",
          details:
            "Tailored dominates US regional woodworking with custom formulations.",
        },
        {
          name: "Henkel",
          position: "Moderate",
          marketShare: "24%",
          revenue: "6% of Henkel revenue",
          focus: "Global furniture brands",
          details: "Serves large international furniture manufacturers.",
        },
        {
          name: "H.B. Fuller",
          position: "Moderate",
          marketShare: "16%",
          revenue: "5% of H.B. Fuller revenue",
          focus: "North American furniture",
          details:
            "Moderate presence targeting larger furniture manufacturers.",
        },
        {
          name: "Bostik",
          position: "Limited",
          marketShare: "10%",
          revenue: "3% of Bostik revenue",
          focus: "European furniture",
          details:
            "Limited presence with some overlap from construction flooring.",
        },
      ],
      keyTakeaways:
        "Woodworking ($4.2B, 4.9% CAGR slowest) is declining in developed markets with intense 4-player competition.",
    },
    "geo-0": {
      name: "North America",
      type: "Geography",
      companies: [
        {
          name: "Henkel",
          position: "Strong",
          marketShare: "24%",
          revenue: "20-23% of Henkel revenue",
          focus: "Broad applications presence",
          details: "North America is mature market (~20-23% global share).",
        },
        {
          name: "H.B. Fuller",
          position: "Dominant",
          marketShare: "32%",
          revenue: "~50% of H.B. Fuller revenue",
          focus: "Primary market, all applications",
          details:
            "H.B. Fuller generates approximately 50% revenue from North America.",
        },
        {
          name: "Bostik",
          position: "Moderate",
          marketShare: "16%",
          revenue: "~25% of Bostik revenue",
          focus: "Construction, packaging",
          details: "North America is secondary market for Bostik.",
        },
        {
          name: "Tailored",
          position: "US Only",
          marketShare: "8%",
          revenue: "100% of Tailored revenue",
          focus: "Woodworking niche",
          details:
            "Tailored is US-only player with 4 facilities in North Carolina.",
        },
      ],
      keyTakeaways:
        "North America ($15.2B, 4.5% CAGR slowest) represents ~20-23% of global market but H.B. Fuller generates 50% of revenue here—massive overweight.",
    },
    "geo-1": {
      name: "Europe",
      type: "Geography",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "35%",
          revenue: "42% of Henkel revenue",
          focus: "All applications, strong construction",
          details:
            "Henkel dominates Europe as home market with headquarters in Germany.",
        },
        {
          name: "Bostik",
          position: "Strong",
          marketShare: "28%",
          revenue: "48% of Bostik revenue",
          focus: "Construction, contractor networks",
          details: "Bostik strong in Europe (French owned by Arkema).",
        },
        {
          name: "H.B. Fuller",
          position: "Growing",
          marketShare: "18%",
          revenue: "~28% of H.B. Fuller revenue",
          focus: "Building European scale",
          details: "Growing presence through Fourny acquisition (2022).",
        },
      ],
      keyTakeaways:
        "Europe ($16.8B, 4.8% CAGR) is second largest region where Henkel (35%) and Bostik (28%) dominate through decades of presence.",
    },
    "geo-2": {
      name: "Asia Pacific",
      type: "Geography",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "32%",
          revenue: "35% of Henkel revenue",
          focus: "China, India manufacturing hubs",
          details: "Henkel leads APAC with extensive manufacturing network.",
        },
        {
          name: "H.B. Fuller",
          position: "Growing",
          marketShare: "22%",
          revenue: "~22% of H.B. Fuller revenue",
          focus: "Expanding manufacturing",
          details:
            "H.B. Fuller underweight in APAC. Critical expansion opportunity.",
        },
        {
          name: "Bostik",
          position: "Moderate",
          marketShare: "16%",
          revenue: "~27% of Bostik revenue",
          focus: "India focus, selective",
          details: "Bostik selective APAC presence with focus on India.",
        },
      ],
      keyTakeaways:
        "APAC ($22.4B, 7.3% CAGR fastest) is the CRITICAL opportunity—largest region globally at 36.2% of market and growing fastest.",
    },
    "seg-0": {
      name: "Construction Contractors",
      type: "Customer Segment",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "30%",
          revenue: "~32% of Henkel revenue",
          focus: "Premium contractors, large projects",
          details: "Construction contractors are key segment for 3 players.",
        },
        {
          name: "H.B. Fuller",
          position: "Growing",
          marketShare: "16%",
          revenue: "~16% of H.B. Fuller revenue",
          focus: "Mid-market contractors",
          details: "Growing mid-market contractor relationships.",
        },
        {
          name: "Bostik",
          position: "Strong",
          marketShare: "28%",
          revenue: "~42% of Bostik revenue",
          focus: "Training programs, certification",
          details:
            "Strong contractor training programs and certification across Europe.",
        },
      ],
      keyTakeaways:
        "Construction contractors ($10.8B) are dominated by Henkel (30%) and Bostik (28%) who invest heavily in training programs.",
    },
    "seg-1": {
      name: "Automotive OEMs",
      type: "Customer Segment",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "42%",
          revenue: "~20% of Henkel revenue",
          focus: "EV battery assembly, structural bonding",
          details:
            "Henkel dominates automotive OEMs with battery testing center (2024).",
        },
        {
          name: "H.B. Fuller",
          position: "Strong",
          marketShare: "35%",
          revenue: "~14% of H.B. Fuller revenue",
          focus: "Automotive filtration, interior",
          details: "Strong position leveraging air filtration expertise.",
        },
      ],
      keyTakeaways:
        "Automotive OEMs ($8.2B, 7.1% CAGR) is dominated by Henkel (42%) with battery testing center for EV applications.",
    },
    "seg-2": {
      name: "Packaging Converters",
      type: "Customer Segment",
      companies: [
        {
          name: "H.B. Fuller",
          position: "Leader",
          marketShare: "32%",
          revenue: "~22% of H.B. Fuller revenue",
          focus: "Sustainable packaging, food-safe",
          details:
            "H.B. Fuller leads packaging converters with focus on sustainability.",
        },
        {
          name: "Bostik",
          position: "Strong",
          marketShare: "28%",
          revenue: "~19% of Bostik revenue",
          focus: "Flexible packaging, sustainable",
          details:
            "Bostik launched sustainable Kizen LIME (80% renewable) in 2024.",
        },
      ],
      keyTakeaways:
        "Packaging converters ($12.5B) show tight 2-player competition between H.B. Fuller (32% leader) and Bostik (28%).",
    },
    "seg-3": {
      name: "Hygiene Manufacturers",
      type: "Customer Segment",
      companies: [
        {
          name: "H.B. Fuller",
          position: "Leader",
          marketShare: "48%",
          revenue: "~32% of H.B. Fuller revenue",
          focus: "Diaper elastic bonding, feminine care",
          details:
            "H.B. Fuller is clear leader in hygiene with dedicated innovation centers.",
        },
      ],
      keyTakeaways:
        "Hygiene manufacturers ($4.2B, 6.8% CAGR) is H.B. Fuller's CROWN JEWEL—48% market share, 32% of company revenue.",
    },
    "seg-4": {
      name: "Wood Manufacturers",
      type: "Customer Segment",
      companies: [
        {
          name: "Tailored",
          position: "Leader",
          marketShare: "42%",
          revenue: "~78% of Tailored revenue",
          focus: "Custom formulations, regional service",
          details:
            "Tailored Chemical dominates US regional woodworking with 100% focus.",
        },
      ],
      keyTakeaways:
        "Wood manufacturers ($4.2B, 4.9% CAGR slowest) is Tailored Chemical's entire business (42% share, 78% of their revenue).",
    },
    "custseg-0": {
      name: "Packaging Converters & CPG Manufacturers",
      type: "Customer Segment",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "28%",
          revenue: "~24% of Henkel revenue",
          focus: "Food packaging, CPG brands",
          details:
            "All major players serve packaging converters and CPG manufacturers.",
        },
        {
          name: "H.B. Fuller",
          position: "Strong",
          marketShare: "24%",
          revenue: "~22% of H.B. Fuller revenue",
          focus: "Sustainable packaging, food-safe",
          details: "Strong position in packaging converters.",
        },
        {
          name: "Bostik",
          position: "Strong",
          marketShare: "21%",
          revenue: "~19% of Bostik revenue",
          focus: "Flexible packaging, sustainable",
          details:
            "Bostik launched sustainable Kizen LIME (80% renewable) in 2024.",
        },
        {
          name: "Tailored",
          position: "Moderate",
          marketShare: "3%",
          revenue: "~8% of Tailored revenue",
          focus: "Wood-based packaging only",
          details:
            "Limited to wood-based packaging like crates in US regional markets.",
        },
      ],
      keyTakeaways:
        "Packaging converters are battlefield segment with all 4 players competing for CPG manufacturers. E-commerce driving 8-10% annual growth.",
    },
    "custseg-1": {
      name: "Construction Contractors & Building Material Suppliers",
      type: "Customer Segment",
      companies: [
        {
          name: "Bostik",
          position: "Leader",
          marketShare: "32%",
          revenue: "~42% of Bostik revenue",
          focus: "Training programs, contractor certification",
          details:
            "Construction contractors major segment (44.7% of market). Bostik leader.",
        },
        {
          name: "Henkel",
          position: "Strong",
          marketShare: "28%",
          revenue: "~32% of Henkel revenue",
          focus: "Premium contractors, large projects",
          details: "Henkel strong but focused on premium segment.",
        },
        {
          name: "H.B. Fuller",
          position: "Growing",
          marketShare: "16%",
          revenue: "~16% of H.B. Fuller revenue",
          focus: "Mid-market contractors, regional",
          details:
            "H.B. Fuller acquired Fourny (2022) building European scale.",
        },
        {
          name: "Tailored",
          position: "Limited",
          marketShare: "2%",
          revenue: "~7% of Tailored revenue",
          focus: "Wood construction only",
          details: "Minimal construction presence.",
        },
      ],
      keyTakeaways:
        "Construction contractors are the LARGEST customer segment at 44.7% of total market—this is where the money is. Bostik dominates with 32% share.",
    },
    "custseg-2": {
      name: "Automotive OEMs & Tier 1 Suppliers",
      type: "Customer Segment",
      companies: [
        {
          name: "Henkel",
          position: "Leader",
          marketShare: "42%",
          revenue: "~20% of Henkel revenue",
          focus: "EV battery assembly, structural bonding",
          details:
            "Henkel leading automotive OEMs with battery testing center (2024).",
        },
        {
          name: "H.B. Fuller",
          position: "Strong",
          marketShare: "24%",
          revenue: "~14% of H.B. Fuller revenue",
          focus: "Automotive filtration, interior",
          details: "Strong position leveraging air filtration expertise.",
        },
        {
          name: "Bostik",
          position: "Moderate",
          marketShare: "12%",
          revenue: "~8% of Bostik revenue",
          focus: "Interior components, NVH",
          details: "Limited automotive presence.",
        },
      ],
      keyTakeaways:
        "Automotive OEMs represent THE future growth opportunity—EVs use 2x more adhesive than traditional vehicles.",
    },
    "custseg-3": {
      name: "Woodworking & Furniture Manufacturers",
      type: "Customer Segment",
      companies: [
        {
          name: "Tailored",
          position: "Leader",
          marketShare: "42%",
          revenue: "~78% of Tailored revenue",
          focus: "Custom formulations, regional service",
          details: "Tailored Chemical dominates US regional woodworking.",
        },
        {
          name: "Henkel",
          position: "Moderate",
          marketShare: "28%",
          revenue: "~7% of Henkel revenue",
          focus: "Global furniture brands, large scale",
          details: "Serves large international furniture manufacturers.",
        },
        {
          name: "H.B. Fuller",
          position: "Moderate",
          marketShare: "18%",
          revenue: "~6% of H.B. Fuller revenue",
          focus: "North American furniture, edge banding",
          details: "Moderate presence in woodworking.",
        },
        {
          name: "Bostik",
          position: "Limited",
          marketShare: "12%",
          revenue: "~3% of Bostik revenue",
          focus: "European furniture, flooring overlap",
          details: "Limited woodworking presence.",
        },
      ],
      keyTakeaways:
        "Woodworking manufacturers are Tailored Chemical's ENTIRE business model (42% share, 78% of revenue).",
    },
    "custseg-4": {
      name: "Hygiene Product Manufacturers",
      type: "Customer Segment",
      companies: [
        {
          name: "H.B. Fuller",
          position: "Leader",
          marketShare: "48%",
          revenue: "~32% of H.B. Fuller revenue",
          focus: "Diaper elastic bonding, feminine care",
          details:
            "H.B. Fuller dominates hygiene segment with dedicated innovation centers.",
        },
        {
          name: "Henkel",
          position: "Strong",
          marketShare: "35%",
          revenue: "~17% of Henkel revenue",
          focus: "Premium adult incontinence, baby care",
          details: "Strong position leveraging global brand relationships.",
        },
        {
          name: "Bostik",
          position: "Limited",
          marketShare: "8%",
          revenue: "~4% of Bostik revenue",
          focus: "Selective hygiene applications",
          details: "Limited presence in hygiene.",
        },
      ],
      keyTakeaways:
        "Hygiene manufacturers (P&G, Kimberly-Clark) are H.B. Fuller's PROFIT ENGINE—48% market share, 32% of revenue, highest margins.",
    },
  };

  const marketData = {
    "tech-0": {
      size: "$18.5B",
      year: "2024",
      cagr: "6.2%",
      period: "2024-2030",
    },
    "tech-1": {
      size: "$14.2B",
      year: "2024",
      cagr: "5.8%",
      period: "2024-2029",
    },
    "tech-2": {
      size: "$8.6B",
      year: "2024",
      cagr: "7.5%",
      period: "2024-2030",
    },
    "tech-3": {
      size: "$9.2B",
      year: "2024",
      cagr: "6.1%",
      period: "2024-2029",
    },
    "app-0": {
      size: "$10.8B",
      year: "2024",
      cagr: "5.8%",
      period: "2024-2029",
    },
    "app-1": {
      size: "$12.5B",
      year: "2024",
      cagr: "5.5%",
      period: "2024-2030",
    },
    "app-2": { size: "$3.8B", year: "2024", cagr: "6.8%", period: "2024-2029" },
    "app-3": { size: "$2.1B", year: "2024", cagr: "8.2%", period: "2024-2030" },
    "app-4": { size: "$4.2B", year: "2024", cagr: "4.9%", period: "2024-2029" },
    "geo-0": {
      size: "$15.2B",
      year: "2024",
      cagr: "4.5%",
      period: "2024-2029",
    },
    "geo-1": {
      size: "$16.8B",
      year: "2024",
      cagr: "4.8%",
      period: "2024-2029",
    },
    "geo-2": {
      size: "$22.4B",
      year: "2024",
      cagr: "7.3%",
      period: "2024-2030",
    },
    "seg-0": {
      size: "$10.8B",
      year: "2024",
      cagr: "5.8%",
      period: "2024-2029",
    },
    "seg-1": { size: "$8.2B", year: "2024", cagr: "7.1%", period: "2024-2030" },
    "seg-2": {
      size: "$12.5B",
      year: "2024",
      cagr: "5.5%",
      period: "2024-2030",
    },
    "seg-3": { size: "$3.8B", year: "2024", cagr: "6.8%", period: "2024-2029" },
    "seg-4": { size: "$4.2B", year: "2024", cagr: "4.9%", period: "2024-2029" },
    "custseg-0": {
      size: "$10.8B",
      year: "2024",
      cagr: "5.8%",
      period: "2024-2029",
    },
    "custseg-1": {
      size: "$12.5B",
      year: "2024",
      cagr: "5.5%",
      period: "2024-2030",
    },
    "custseg-2": {
      size: "$8.2B",
      year: "2024",
      cagr: "7.1%",
      period: "2024-2030",
    },
    "custseg-3": {
      size: "$3.8B",
      year: "2024",
      cagr: "6.8%",
      period: "2024-2029",
    },
    "custseg-4": {
      size: "$4.2B",
      year: "2024",
      cagr: "4.9%",
      period: "2024-2029",
    },
  };

  const renderPositionDots = (position, companyName) => {
    const dotsCount =
      position === "Leader" || position === "Dominant"
        ? 5
        : position === "Strong"
        ? 4
        : position === "Growing" || position === "Moderate"
        ? 3
        : position === "Limited"
        ? 2
        : position === "None"
        ? 0
        : 1;

    const companyColors = {
      Henkel: "danger",
      "H.B. Fuller": "primary",
      Bostik: "info",
      Tailored: "secondary",
    };

    const color = companyColors[companyName] || "secondary";

    return (
      <div
        className="d-flex gap-1 align-items-center"
        title={`${companyName}: ${position}`}
      >
        {[...Array(5)].map((_, idx) => (
          <div
            key={idx}
            className={`rounded-circle ${
              idx < dotsCount
                ? `bg-${color}`
                : "bg-light border border-2 border-secondary"
            }`}
            style={{ width: "12px", height: "12px" }}
          ></div>
        ))}
      </div>
    );
  };

  if (!selectedDetailModal) return null;

  const modalData = detailedCompetitiveData[selectedDetailModal];
  if (!modalData) return null;

  return (
    <Modal
      show={!!selectedDetailModal}
      onHide={() => setSelectedDetailModal(null)}
      size="xl"
      centered
      scrollable
    >
      <style>{`
        .modal-header-gradient {
          font-weight: 600;
          font-size: 14px;
          line-height: 17.5px;
          color: #1e1c25;
          margin-bottom: 3px;
        }
        .market-info-bar {
          background: #f7f9ff;
          padding: 1.5rem;
          border-bottom: 2px solid #d0deff;
        }
        .market-stat {
          padding: 12px;
          background: #fff;
          border-radius: 8px;
          font-size:14px;
          border-left: 4px solid #6610f2;
        }
        .tab-button {
          padding: 12px 16px;
          border-radius: 0.5rem;
          font-weight: 500;
          font-size: 13px;
          transition: all 0.3s;
          border: none;
          cursor: pointer;
        }
        .tab-button-active {
          background: #4E6BCA;
          color: #fff;
          font-weight: 500;
          box-shadow: 0 2px 8px rgba(102,16,242,0.4);
        }
        .tab-button-inactive {
          background: #fff;
          color: #6c757d;
          border: 1px solid #dee2e6;
        }
        .tab-button-inactive:hover {
          background: #f8f9fa;
          border-color: #6610f2;
        }
        .company-row-bostik {
          background: #d1ecf1 !important;
        }
        .company-row-henkel {
          background: #f8d7da !important;
        }
        .company-row-hbfuller {
          background: #cfe2ff !important;
        }
        .company-row-tailored {
          background: #e2e3e5 !important;
        }
        .company-row td {
          padding: 12px;
          position: relative;
          border-bottom: 1px solid #e2e8f0;
          border-right: 1px solid #e2e8f0;
          white-space: normal;
          overflow: hidden;
          word-break: break-word;
          vertical-align: middle;
          font-weight: unset;
          font-size: 12px;
        }
        .takeaway-box {
          background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
          border-left: 5px solid #ffa726;
          border-radius: 8px;
          padding: 12px 16px;
        }
        .modal-content {
          border: none;
          border-radius: 1rem;
          overflow: hidden;
        }
        .close-button {
          background: #fff;
          border: none;
          border-radius: 0.375rem;
          padding: 0.5rem;
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
        }
        .close-button:hover {
          background: #f8f9fa;
          transform: scale(1.1);
        }
        .modal-title-new{
          font-size: 16px;
          font-weight: 600 !important;
        }
      `}</style>

      <Modal.Header className="modal-header-gradient border-0">
        <div className="d-flex justify-content-between align-items-start w-100">
          <div>
            <div className="text-sm opacity-90 mb-1">
              {modalData.type} Deep Dive
            </div>
            <Modal.Title className="text-2xl font-bold text-white modal-title-new d-inline">
              <span className="modal-title-new">{modalData.name}</span>
              <a
                href="https://www.marketsandmarkets.com/knowledgestore.asp"
                target="_blank"
                rel="noopener noreferrer"
                class="px-4 py-2 bg-blue-600 text-sm font-semibold rounded-lg hover:bg-blue-700 transition flex items-center gap-2 font12"
              >
                <span>📊</span> View Market Report
              </a>
            </Modal.Title>
          </div>
          <button
            onClick={() => setSelectedDetailModal(null)}
            className="close-button"
          >
            <X size={20} color="#6610f2" />
          </button>
        </div>
      </Modal.Header>

      {marketData[selectedDetailModal] && (
        <div className="market-info-bar">
          <div className="row g-3">
            <div className="col-md-6">
              <div className="market-stat">
                <div
                  className="small text-uppercase mb-2"
                  style={{ color: "#6610f2", letterSpacing: "0.5px" }}
                >
                  MARKET SIZE
                </div>
                <div
                  className="h2 fw-bold mb-1"
                  style={{ color: "#1e293b", fontSize: "16px" }}
                >
                  {marketData[selectedDetailModal].size}
                </div>
                <div className="small text-muted">
                  Global ({marketData[selectedDetailModal].year})
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="market-stat">
                <div
                  className="small text-uppercase mb-2"
                  style={{ color: "#6610f2", letterSpacing: "0.5px" }}
                >
                  GROWTH RATE
                </div>
                <div
                  className="h2 fw-bold mb-1 text-success"
                  style={{ fontSize: "16px" }}
                >
                  {marketData[selectedDetailModal].cagr}
                </div>
                <div className="small text-muted">
                  CAGR {marketData[selectedDetailModal].period}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="bg-light p-3">
        <div className="d-flex gap-2">
          {[
            { id: "market_share", label: "Market Position" },
            { id: "revenue", label: "Revenue Contribution" },
            {
              id: "focus",
              label:
                modalData.type === "Customer Segment"
                  ? "Key Pain Points"
                  : "Company Focus",
            },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setDetailModalView(tab.id)}
              className={`tab-button ${
                detailModalView === tab.id
                  ? "tab-button-active"
                  : "tab-button-inactive"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <Modal.Body className="p-0">
        <div className="table-responsive">
          <table className="custom-resizable-table p-3">
            <thead
              style={{
                background: "#f8f9fa",
                borderBottom: "2px solid #dee2e6",
              }}
            >
              <tr className="custom-resizable-table-header">
                <th className="fw-bold py-3 px-4" style={{ width: "15%" }}>
                  <div className="custom-resizable-table-th-content">
                    Company
                  </div>
                </th>
                <th className="fw-bold py-3 px-4" style={{ width: "20%" }}>
                  <div className="custom-resizable-table-th-content">
                    {" "}
                    Market Position
                  </div>
                </th>
                {detailModalView === "market_share" && (
                  <th className="fw-bold py-3 px-4" style={{ width: "15%" }}>
                    <div className="custom-resizable-table-th-content">
                      Market Share
                    </div>
                  </th>
                )}
                {detailModalView === "revenue" && (
                  <th className="fw-bold py-3 px-4" style={{ width: "20%" }}>
                    <div className="custom-resizable-table-th-content">
                      {" "}
                      Revenue Contribution
                    </div>
                  </th>
                )}
                {detailModalView === "focus" && (
                  <th className="fw-bold py-3 px-4" style={{ width: "25%" }}>
                    {modalData.type === "Customer Segment"
                      ? "Key Pain Points"
                      : "Strategic Focus"}
                  </th>
                )}
                <th className="fw-bold py-3 px-4">
                  <div className="custom-resizable-table-th-content">
                    Key Details
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {modalData.companies.map((company, idx) => {
                const companyRowClass =
                  company.name === "Henkel"
                    ? "company-row-henkel"
                    : company.name === "H.B. Fuller"
                    ? "company-row-hbfuller"
                    : company.name === "Bostik"
                    ? "company-row-bostik"
                    : "company-row-tailored";

                return (
                  <tr key={idx} className={`company-row ${companyRowClass}`}>
                    <td className="px-4 fw-bold">{company.name}</td>
                    <td className="px-4">
                      {renderPositionDots(company.position, company.name)}
                    </td>
                    {detailModalView === "market_share" && (
                      <td className="px-4">{company.marketShare}</td>
                    )}
                    {detailModalView === "revenue" && (
                      <td className="px-4">{company.revenue}</td>
                    )}
                    {detailModalView === "focus" && (
                      <td className="px-4">{company.focus}</td>
                    )}
                    <td className="px-4 text-muted">{company.details}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="p-4">
          <div className="takeaway-box">
            <div className="d-flex gap-3 align-items-start">
              <span style={{ fontSize: "1rem" }}>💡</span>
              <div className="flex-grow-1">
                <div
                  className="fw-bold mb-2"
                  style={{ fontSize: "14px", color: "#1e293b" }}
                >
                  Key Takeaways
                </div>
                <p
                  className="mb-0"
                  style={{
                    lineHeight: "1.6",
                    color: "#475569",
                    fontSize: "13px",
                  }}
                >
                  {modalData.keyTakeaways}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DetailModal;
